import { Outlet, ScrollRestoration } from 'react-router-dom';
import '@/layouts/Negative/stylesLayout';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import classes from './style.module.css';

const NegativeLayout = () => (
  <div className={classes.layout}>
    <ScrollRestoration />
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer isFixed isNegative />
  </div>
);

export default NegativeLayout;
